export const EnquiryTabKeys = {
  Overview: "overview",
  Email: "email",
  Documents: "documents",
  Quote: "currentQuote",
  Visits: "visits",
  Equipment: "equipment",
};

export const JobTabKeys = {
  Overview: "overview",
  Documents: "documents",
  ScopeOfWork: "scopeOfWork",
  Schedule: "schedule",
  RepeatSchedule: "repeatSchedule",
  Equipment: "equipment",
  FulfilmentOfWorks: "fulfilmentOfWorks",
};

export const InvoicedStatus = {
  ReadyToInvoice: "ReadyToInvoice",
  Invoiced: "Invoiced",
};

export const DepartmentColourOptions = {
  DarkRed: "#b94f5f",
  Red: "#ff363e",
  Orange: "#ff7f27",
  Yellow: "#fff200",
  Green: "#22b14c",
  Turquoise: "#00a2e8",
  Indigo: "#737cff",
  Purple: "#a349a4",
  Brown: "#b97a57",
  Rose: "#ffaec9",
  Gold: "#ffc90e",
  LightYellow: "#efe4b0",
  Lime: "#b5e61d",
  LightTurquoise: "#99d9ea",
  BlueGrey: "#7092be",
  Lavender: "#c8bfe7",
};

export const DepartmentColourNames = {
  DarkRed: "Dark Red",
  Red: "Red",
  Orange: "Orange",
  Yellow: "Yellow",
  Green: "Green",
  Turquoise: "Turquoise",
  Indigo: "Indigo",
  Purple: "Purple",
  Brown: "Brown",
  Rose: "Rose",
  Gold: "Gold",
  LightYellow: "Light Yellow",
  Lime: "Lime",
  LightTurquoise: "Light Turquoise",
  BlueGrey: "Blue-Grey",
  Lavender: "Lavender",
};

export const ContractTabKeys = {
  Overview: "overview",
  Documents: "documents",
  PlotWorksFencing: "plotWorksFencing",
  PlotWorksLandscaping: "plotWorksLandscaping",
  PosWorksFencing: "posWorksFencing",
  PosWorksLandscaping: "posWorksLandscaping",
  InfrastructureWorks: "infrastructureWorks",
  MaintenanceWorks: "maintenanceWorks",
  JobManagement: "jobManagement",
  RiskAssessment: "riskAssessment",
  AdditionalWorks: "additionalWorks",
};

export const DashboardWidgetKeys = {
  ContractInvoiceValue: "ContractInvoiceValue",
  ContractJobStatus: "ContractJobStatus",
  ContractStatus: "ContractStatus",
  ContractCustomer: "ContractCustomer",
  ContractsByValue: "ContractsByValue",
  JobsByDepartment: "JobsByDepartment",
  Enquiries: "Enquiries",
  Quotes: "Quotes",
  Jobs: "Jobs",
};

export const DocumentTypeIds = {
  JobSheet: "d4a1f8e2-3b7c-4f91-a562-8c0e5d2b9f14",
  Estimate: "7f2c94a1-e8b3-4d06-b715-3a9c0e6f2d58",
  Quote: "b83e1d5c-4a92-4f7b-8e06-1c5d3f9a2e74",
  Invoice: "2e6a0c9f-7d14-4b83-9f52-6a8c1e3d5b07",
  General: "f5c3a8d1-2e90-4b76-a014-9d5f2c8e3b61",
  RiskAssessment: "91d7b2e5-6c04-4a38-b9f1-2e7d5c0a8f43",
  Rams: "3a8f1c64-b295-4e07-9d53-7f1a2c8e0b96",
  Other: "c70e4f92-1d85-4b63-a2f8-5e9c0d3b7a14",
  Contract: "6b2d9e31-a784-4c50-8f37-1d5b0c9e2a68",
  SitePhotos: "e4190c7b-3f82-4d65-a951-8b2f0e6c4d37",
  SiteDrawings: "08f5a3c9-7b14-4e82-b063-2d9f1c5a7e80",
  PlantList: "5c7e0b84-2d91-4f36-a8c1-9f3d6e0b2a75",
  MaterialsList: "a3f8d261-9c40-4b17-8e53-0f7d2c5a9b64",
  WorkOrder: "4d1e8c05-6b73-4a92-f180-3c9a5e2d7b08",
};
